<template>
  <div class="home-mobile">
    <!-- 主视觉区（Banner+介绍+按钮） -->
    <section class="hero-section">
      <div class="hero-banner">
        <div class="hero-title-group">
          <div class="hero-title">
            {{ $t("home.banner.title1") }}<br />
            {{ $t("home.banner.title2") }}<br />
            {{ $t("home.banner.title3") }}
            <img class="hero-title-underline" src="@/assets/images/yellow.png" alt="underline" :style="{
              right: $i18n.locale === 'zh' ? '20%' : '50%',
              top: $i18n.locale === 'zh' ? '20%' : '15%',
            }" />
          </div>
          <div class="hero-btns">
            <ConsultButton @click="onConsultClick" :text="$t('home.banner.ask')" />
            <!-- <button class="evaluate-btn" size="medium" plain @click="goToEvaluation">
              {{ $t("home.banner.Evaluation") }}
            </button> -->
          </div>
        </div>
      </div>
    </section>

    <!-- 主视觉图片 -->
    <section class="hero-visual-section">
      <div class="hero-images-wrapper">
        <img class="hero-img responsive-banner" :src="banner6Src" alt="banner6" />
      </div>
    </section>

    <!-- 合并info-bar和partners-section -->
    <div class="info-partners-section">
      <div class="info-bar">
        <div class="info-bar-content">
          <div class="info-bar-text">
            <div class="info-bar-text-item1">
              {{
                $i18n.locale === "zh"
                  ? "剑桥科博留学"
                  : "HOPE Guardianship"
              }}
            </div>
            <div class="info-bar-text-item2">
              <span> {{ $i18n.locale === "zh" ? "20+" : "20+" }}</span>
              <span style="font-size: 12px; opacity: 0.87">
                {{
                  $i18n.locale === "zh" ? "合作名校" : "Partner Schools in UK"
                }}</span>
            </div>
          </div>
          <div class="">
            <img class="info-bar-underline" :src="require('@/assets/images/yellow.png')" alt="underline" :style="{
              top: $i18n.locale === 'zh' ? '72%' : '107%',
              left: $i18n.locale === 'zh' ? '0%' : '0%',
            }" />
          </div>
        </div>
      </div>
      <section class="partners-section">
        <div class="partners-logos-row" v-for="(row, rowIdx) in logoRows" :key="rowIdx">
          <div class="school-slider" :class="rowIdx === 0 ? 'slide-left' : 'slide-right'">
            <img v-for="(logo, idx) in row.concat(row)" :key="`${rowIdx}-${idx}`" :src="logo"
              :alt="`School logo ${rowIdx * 16 + (idx % 16) + 1}`" />
          </div>
        </div>
      </section>
    </div>

    <!-- 细心守护功能 -->
    <section class="caring-guardianship-section">
      <div class="caring-container">
        <div class="caring-title">
          <div class="caring-title-text">
            <span class="title-text">{{ $t("caring.title") }}</span>
            <div class="title-underline">
              <img class="hero-title-underline" :src="require('@/assets/images/yellow.png')" alt="underline" />
            </div>
          </div>
        </div>
        <div class="caring-cards" ref="caringCards">
          <div class="caring-card" v-for="(card, index) in caringCards" :key="index" @click="handleCardClick(index)"
            :class="{ 'first-card': index === 0 }">
            <div class="card-box" :class="getCardBgClass(index)">
              <div class="card-content" :class="index % 2 === 0 ? 'content-top' : 'content-bottom'">
                <div v-if="index % 2 === 0" class="text-content">
                  <div class="card-title">
                    <template v-if="index === 1">
                      <span class="black-text">专业、可信的</span>
                      <span class="gold-text">学业守护</span>
                    </template>
                    <template v-else-if="index === 2 && $i18n.locale === 'en'">
                      <div style="display: flex; flex-direction: column">
                        <div class="gold-text">{{ "Emergency" }}</div>
                        <div class="black-text">Support</div>
                      </div>
                    </template>
                    <template v-else>
                      <span class="gold-text">{{
                        getTitleGoldPart(index)
                      }}</span>
                      <span class="black-text">{{
                        getTitleBlackPart(index)
                      }}</span>
                    </template>
                  </div>
                  <div class="card-subtitle" v-if="$t(`home.cardTitles.card${index}.subtitle`)">
                    {{ $t(`home.cardTitles.card${index}.subtitle`) }}
                  </div>
                  <p class="card-description">
                    {{ $t(`home.cardTitles.card${index}.desc`) }}
                  </p>
                  <p class="card-note" v-if="index === 0">
                    {{ $t("home.cardTitles.card0.note") }}
                  </p>
                </div>

                <div class="card-icon" :class="index % 2 === 0 ? 'icon-bottom' : 'icon-top'">
                  <img :src="getCardIcon(index)" alt="icon" class="icon-img" />
                </div>

                <div v-if="index % 2 !== 0" class="text-content">
                  <div class="card-title">
                    <template v-if="index === 1 && $i18n.locale === 'zh'">
                      <span class="black-text">专业可信的</span>
                      <span class="gold-text">学业守护</span>
                    </template>
                    <template v-else-if="index === 1 && $i18n.locale === 'en'">
                      <div style="display: flex; flex-direction: column">
                        <div class="black-text">Professional and reliable academic support</div>
                        <div class="gold-text">From school selection to course choice</div>
                      </div>
                    </template>

                    <template v-else>
                      <span class="gold-text">{{
                        getTitleGoldPart(index)
                      }}</span>
                      <span class="black-text">{{
                        getTitleBlackPart(index)
                      }}</span>
                    </template>
                  </div>
                  <div class="card-subtitle" v-if="$t(`home.cardTitles.card${index}.subtitle`)"
                    style="white-space: pre-line;">
                    {{ $t(`home.cardTitles.card${index}.subtitle`) }}
                  </div>
                  <p class="card-description">
                    {{ $t(`home.cardTitles.card${index}.desc`) }}
                  </p>
                </div>

                <div class="arrow-box" :class="index % 2 === 0 ? 'arrow-bottom' : 'arrow-top'">
                  <img :src="require('@/assets/images/Arrow 2.png')" alt="Arrow" class="arrow-img" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 悉心关照功能 -->
    <section class="meticulous-care-section-flow">
      <div class="brand-story-card-flow">
        <!-- <div class="brand-story-title">{{ $t("home.story.title") }}</div> -->
        <img class="brand-story-underline" src="@/assets/images/yellow.png" alt="underline" :style="{
          top: $i18n.locale === 'zh' ? '18%' : '14%',
          left: $i18n.locale === 'zh' ? '55%' : '37%',
        }" />
        <div class="brand-story-main-title" style="white-space: pre-line">
          {{ $t("home.story.desc") }}
        </div>
        <div class="brand-story-desc">
          {{ $t("home.story.desc2") }}
        </div>
        <button class="brand-story-btn" @click="handleMeticulousCareLearnMore">
          {{ $t("home.story.button") }}
        </button>
      </div>
    </section>

    <!-- Who We Are 区块 -->

    <section style="padding: 0 20px; padding-top: 40px; margin-bottom: 20px">
      <div class="accreditation-section">
        <div class="accreditation-content">
          <div class="accreditation-text">
            <div class="accreditation-title">
              {{ $t("about.company.title") }}
            </div>
            <div class="accreditation-desc">
              {{ $t("about.company.desc") }}
            </div>
            <button class="brand-story-btn" @click="authentication">
              {{ $t("about.company.button") }}
            </button>
          </div>
          <div class="accreditation-img">
            <img src="@/assets/images/BrandStory/aegis.png" alt="AEGIS" />
          </div>
        </div>
      </div>
    </section>
    <!-- <section class="img-section">
      <img src="@/assets/images/banner.png" alt="AEGIS" />
    </section> -->

    <!-- 金牌监护人背景区块 -->
    <section class="guardian-background-section">
      <div class="guardian-title-box">
        <div class="guardian-title">{{ $t("home.godTitle") }}</div>
        <img class="guardian-title-underline" src="@/assets/images/yellow.png" alt="underline" />
      </div>
      <!-- 表格区块 -->
      <div class="guardian-bg-table">
        <div class="guardian-bg-row" v-for="(row, idx) in guardianBgRows" :key="idx"
          @click="navigateToBrandStory(row.year)">
          <div class="guardian-bg-col year">{{ row.year }}</div>
          <div class="guardian-bg-col event">{{ row.event }}</div>
          <div class="guardian-bg-col desc">{{ row.desc }}</div>
        </div>
      </div>
    </section>

    <!-- 舍监/学校反馈 -->
    <section class="school-feedback-section">
      <div class="school-feedback-container">
        <!-- 标题区域 -->
        <div class="school-feedback-title-box">
          <div class="school-feedback-title">
            {{ $t("home.schoolFeedbackTitle2") }}
          </div>
          <div class="school-feedback-main-title" style="white-space: pre-line">
            {{ $t("home.schoolFeedbackTitle") }}
          </div>
          <img class="school-feedback-title-underline" src="@/assets/images/yellow.png" alt="underline"
            :style="{ left: schoolFeedbackTitleUnderlineLeft }" />
        </div>

        <!-- 轮播内容区域 -->
        <div class="school-feedback-carousel">
          <div class="custom-swipe-container">
            <!-- 轮播内容 -->
            <div class="custom-swipe-wrapper" ref="swipeWrapper">
              <div class="custom-swipe-track" :style="{
                transform: `translateX(-${currentSchoolFeedbackIndex * 100
                  }%)`,
              }" ref="swipeTrack">
                <div v-for="(item, index) in schoolFeedbackData" :key="index" class="custom-swipe-item">
                  <div class="feedback-content">
                    <!-- 学校图标 -->
                    <div class="school-icon">
                      <img :src="item.icon" :alt="item.school" />
                    </div>

                    <!-- 评价人信息 -->
                    <div class="feedback-author">
                      <div class="author-name">{{ item.author }}</div>
                      <div class="author-title">{{ item.title }}</div>
                    </div>

                    <!-- 评价内容 -->
                    <div class="feedback-quote">
                      <img class="quote-mark quote-mark-left" src="@/assets/images/yinhaoleft.png" alt="quote mark" />
                      <div class="quote-text">
                        <div class="quote-text-line">
                          {{item.quote.map((line) => line.line).join(" ")}}
                        </div>
                      </div>
                      <img class="quote-mark quote-mark-right" src="@/assets/images/yinhaoright.png" alt="quote mark" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 指示器 (保持原有样式) -->
            <div class="custom-swipe-indicators">
              <span v-for="(item, index) in schoolFeedbackData" :key="index" class="custom-indicator" :class="{
                'custom-indicator-active':
                  index === currentSchoolFeedbackIndex,
              }" @click="goToSlide(index)"></span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 客户感言 -->
    <section class="customer-testimonials-section" ref="testimonialsSection">
      <span class="school-feedback-title">{{
        $t("home.customerTestimonialsDesc")
      }}</span>
      <div class="customer-testimonials-title">
        <span>{{ $t("home.customerTestimonialsTitle") }}</span>
        <img class="customer-testimonials-underline" src="@/assets/images/yellow.png" alt="underline"
          :style="customerTestimonialsUnderlineStyle" />
      </div>
      <div class="customer-testimonials-container">
        <van-swipe v-model="testimonialStep" :show-indicators="true" indicator-color="#282938" :loop="false"
          class="testimonials-swipe">
          <van-swipe-item v-for="(item, idx) in testimonials" :key="idx" style="margin-bottom: 48px">
            <div class="customer-testimonials-left">
              <!-- 头像和用户信息 -->
              <div class="testimonial-meta">
                <img class="avatar" :src="require('@/assets/images/Testimonials/touxiang.png')" alt="avatar" />
                <div class="meta-info">
                  <div class="meta-name">{{ item.user }}</div>
                  <div class="meta-school" style="white-space: pre-line">
                    {{ item.school || "家长" }}
                  </div>
                </div>
              </div>
              <div class="customer-testimonials-right">
                <img class="customer-testimonials-img" :src="item.img" alt="testimonial" />
              </div>
              <!-- 感言内容 -->
              <div class="yinhao">
                <img src="@/assets/images/Testimonials/yinhao.png" alt="yinhao" />
              </div>
              <div class="testimonial-quote">
                <i class="el-icon-quote-left"></i>
                <p class="testimonial-text" style="white-space: pre-line" v-html="item.desc"></p>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="testimonial-bottom-bar">
        <div class="testimonial-desc"></div>
        <button class="testimonial-learn-btn" @click="goToTestimonials">
          {{ $t("home.customerTestimonialsLearnMore") }}
        </button>
      </div>
    </section>

    <!-- 客户感言下方描述和按钮 -->

    <!-- 家长可能关心的事区块 -->
    <section class="parent-faq-section">
      <div class="parent-faq-container">
        <!-- 左侧 -->
        <div class="parent-faq-left">
          <div class="parent-faq-subtitle">
            {{ $t("home.whoWeAre.containerDesc") }}
          </div>
          <div class="parent-faq-title">
            {{ $t("home.whoWeAre.containerTitle") }}
          </div>
          <img class="parent-faq-underline" src="@/assets/images/yellow.png" alt="underline" />
          <!-- <button class="parent-faq-btn" @click="handleParentFaqBtn">
            {{ $t("home.whoWeAre.containerBtn") }}
          </button> -->
        </div>
        <!-- 右侧 -->
        <div class="parent-faq-right">
          <div class="parent-faq-list">
            <div class="parent-faq-item" v-for="(item, idx) in parentFaqList" :key="idx">
              <div class="parent-faq-qrow" @click="toggleFaq(idx)">
                <span class="parent-faq-number">{{ item.number }}</span>
                <span class="parent-faq-question">{{ item.question }}</span>
                <span class="parent-faq-toggle">{{
                  activeFaq === idx ? "×" : "+"
                }}</span>
              </div>
              <div class="parent-faq-answer" v-if="activeFaq === idx && item.answer">
                {{ item.answer }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 博客区块 -->
    <section class="blog-section">
      <div class="blog-header">
        <div class="blog-title">{{ $t("blog") }}</div>
        <button class="blog-more-btn" type="text" @click="goToBlogList">
          {{ $t("more") }}
        </button>
      </div>
      <div class="blog-list">
        <router-link v-for="(item, idx) in blogList.slice(0, 3)" :key="idx" class="blog-card" :to="`/blog/${item.id}`">
          <div class="blog-img-box">
            <img :src="item.img" :alt="item.title" />
          </div>
          <div class="blog-date">{{ item.date }}</div>
          <div class="blog-title-text">{{ item.title }}</div>
          <div class="blog-desc">{{ item.desc }}</div>
          <span class="blog-link">{{ $t("readMore") }} <span>→</span></span>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from "vant";
export default {
  name: "HomeMobile",
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  mounted() {
    const caringCards = this.$refs.caringCards;
    if (caringCards) {
      caringCards.addEventListener("wheel", this.handleCardsWheel, {
        passive: false,
      });
    }
    if (this.$refs.testimonialsSection) {
      this.$refs.testimonialsSection.addEventListener(
        "wheel",
        this.handleTestimonialsWheel,
        { passive: false }
      );
    }
    // 启动自动滚动
    this.startAutoScroll();

    // 初始化自定义轮播
    this.$nextTick(() => {
      this.initCustomSwipe();
      // 延迟一点时间确保DOM完全渲染
      setTimeout(() => {
        this.adjustWrapperHeight();
      }, 100);
    });
  },
  beforeDestroy() {
    const caringCards = this.$refs.caringCards;
    if (caringCards) {
      caringCards.removeEventListener("wheel", this.handleCardsWheel);
    }
    if (this.$refs.testimonialsSection) {
      this.$refs.testimonialsSection.removeEventListener(
        "wheel",
        this.handleTestimonialsWheel
      );
    }
    // 清理滚动定时器
    clearInterval(this.scrollTimer);
    // 清理自定义轮播事件
    this.cleanupCustomSwipe();
  },
  watch: {
    // 监听轮播索引变化，动态调整高度
    currentSchoolFeedbackIndex() {
      this.$nextTick(() => {
        this.adjustWrapperHeight();
      });
    },
    // 监听语言变化，重新调整高度
    "$i18n.locale"() {
      this.$nextTick(() => {
        // 延迟一点时间确保新语言内容完全渲染
        setTimeout(() => {
          this.adjustWrapperHeight();
        }, 200);
      });
    },
  },
  computed: {
    // 客户感言数据
    testimonials() {
      return this.$t("home.customerTestimonialsList");
    },

    // 根据当前语言返回对应的卡片数据
    caringCards() {
      // 现在卡片内容通过模板中的方法动态生成，只需要返回5个卡片的基础数据
      const cards = [];
      for (let i = 0; i < 4; i++) {
        cards.push({
          index: i,
        });
      }
      return cards;
    },
    whoWeAreImage() {
      const locale = this.$i18n.locale;
      try {
        return require(`@/assets/images/Whoweare-${locale === "zh" ? "ch" : "en"
          }.png`);
      } catch (e) {
        return require("@/assets/images/logo.png");
      }
    },
    // 悉心关照背景图片
    meticulousCareBg() {
      try {
        return require("@/assets/images/xixinguanzhao-bg.png");
      } catch (e) {
        return require("@/assets/images/logo.png");
      }
    },
    // 悉心关照标题图片（根据语言切换）
    meticulousCareTitleImage() {
      const locale = this.$i18n.locale;
      try {
        return require(`@/assets/images/xixinguanzhao-${locale === "zh" ? "ch" : "en"
          }.png`);
      } catch (e) {
        return require("@/assets/images/logo.png");
      }
    },
    blogList() {
      const list = this.$t("blogList");
      return list.map((item, idx) => ({ ...item, id: idx + 1 }))
        .filter(item => item.id !== 3); // 过滤掉id为3的博客
    },
    guardianBgRows() {
      return this.$t("guardianBgRows");
    },
    parentFaqList() {
      return this.$t("parents.faq.list");
    },
    // 学校反馈数据
    schoolFeedbackData() {
      return this.$t("home.schoolFeedback");
    },

    // Banner图片路径
    banner6Src() {
      return require("@/assets/images/banner6.png");
    },
    // 学校反馈标题下划线位置（根据语言调整）
    schoolFeedbackTitleUnderlineLeft() {
      return this.$i18n.locale === "zh" ? "33%" : "20%";
    },
    // 客户感言下划线位置（根据语言调整）
    customerTestimonialsUnderlineStyle() {
      if (this.$i18n.locale === "zh") {
        return {
          left: "0%",
          bottom: "-5px",
        };
      } else {
        return {
          left: "18%",
          bottom: "0%",
        };
      }
    },
    banner2Src() {
      return require("@/assets/images/banner2.png");
    },
    banner3Src() {
      return require("@/assets/images/banner3.png");
    },
    banner4Src() {
      return require("@/assets/images/banner4.png");
    },
    banner5Src() {
      return require("@/assets/images/banner5.png");
    },
    logoRows() {
      // 生成32个logo路径，分成2行，每行16个
      const logos = [];
      for (let i = 0; i < 32; i++) {
        logos.push(require(`@/assets/images/school/School(${i}).png`));
      }
      return [logos.slice(0, 16), logos.slice(16, 32)];
    },
  },
  data() {
    return {
      testimonialStep: 0,
      activeFaq: 0,
      scrollTimer: null,
      scrollStep: 1,
      scrollInterval: 40,
      currentSchoolFeedbackIndex: 0,
      // 移除touch相关data
    };
  },
  methods: {
    goToEvaluation() {
      this.$router.push("/Practice");
    },
    handleCardClick(index) {
      console.log("卡片被点击", index);
      this.$router.push("/services");
    },
    authentication() {
      //移动端跳转到https://aegisuk.net/organisations/?college=Guardianship&org_type=gold-standard
      window.location.href =
        "https://aegisuk.net/organisations/?college=Guardianship&org_type=gold-standard";
    },
    handleParentFaqBtn() {
      this.$router.push("/Practice");
    },
    onConsultClick() {
      this.$router.push("/Practice");
      console.log("移动端立即咨询按钮被点击");
    },

    goToBlogList() {
      this.$router.push("/blog");
    },

    goToTestimonials() {
      this.$router.push("/testimonials");
    },

    handleCardsWheel(e) {
      if (e.deltaY !== 0) {
        e.preventDefault();
        this.$refs.caringCards.scrollLeft += e.deltaY;
      }
    },
    handleTestimonialsWheel(e) {
      e.preventDefault();
      if (this.testimonialStep < this.testimonials.length) {
        this.testimonialStep++;
      } else {
        this.testimonialStep = 0;
      }
      this.$nextTick(() => {
        const el = this.$refs.testimonialText;
        if (el) el.scrollTop = 0;
        this.startAutoScroll();
      });
    },
    // 已移除自动滚动功能
    startAutoScroll() {
      // 不再需要
    },
    pauseScroll() {
      // 不再需要
    },
    resumeScroll() {
      // 不再需要
    },
    toggleFaq(idx) {
      this.activeFaq = this.activeFaq === idx ? -1 : idx;
    },
    handleMeticulousCareLearnMore() {
      // 处理悉心关照"了解更多"按钮点击事件
      console.log("悉心关照了解更多按钮被点击");
      // 这里可以添加跳转逻辑，比如跳转到关于页面或其他相关页面
      this.$router.push("/about");
    },
    navigateToBrandStory(year) {
      // 跳转到品牌故事页面，并传递年份参数
      this.$router.push({
        path: "/about",
        query: { year: year },
      });
    },
    // 新增方法：获取卡片图标
    getCardIcon(index) {
      // 使用提供的图标，按照正确的顺序
      const icons = {
        0: require("@/assets/images/Icon1.png"), // AEGIS金牌监护人图标
        1: require("@/assets/images/Icon2.png"), // 学业图标
        2: require("@/assets/images/Icon3.png"), // 紧急响应图标
        3: require("@/assets/images/Icon4.png"), // 家的温暖图标
        4: require("@/assets/images/Icon5.png"), // 成长理财课图标
      };
      return icons[index] || require("@/assets/images/Icon1.png");
    },
    // 新增方法：获取标题金色部分
    getTitleGoldPart(index) {
      const locale = this.$i18n.locale;
      const isZh = locale === "zh";

      // 根据不同卡片的索引返回黄色部分
      if (isZh) {
        switch (index) {
          case 0:
            return "AEGIS";
          case 1:
            return "学业守护";
          case 2:
            return "紧急响应";
          case 3:
            return "家的温暖";
          case 4:
            return "成长理财课";
          default:
            return "";
        }
      } else {
        switch (index) {
          case 0:
            return "AEGIS Gold Standard ";
          case 1:
            return "";
          case 2:
            return "<2-Hour";
          case 3:
            return "A warm home";
          case 4:
            return "Financial";
          default:
            return "";
        }
      }
    },
    // 新增方法：获取标题黑色部分
    getTitleBlackPart(index) {
      const locale = this.$i18n.locale;
      const isZh = locale === "zh";

      // 根据不同卡片的索引返回黑色部分
      if (isZh) {
        switch (index) {
          case 0:
            return "金牌认证";
          case 1:
            return "专业可信的";
          case 2:
            return "";
          case 3:
            return "";
          case 4:
            return "";
          default:
            return "";
        }
      } else {
        switch (index) {
          case 0:
            return "";
          case 1:
            return "";
          case 2:
            return "Emergency Response";
          case 3:
            return "";
          case 4:
            return "";
          default:
            return "";
        }
      }
    },
    // 新增方法：获取卡片背景类名
    getCardBgClass(index) {
      // 根据卡片索引返回不同的背景图片类名
      return index % 2 === 0 ? "bg-down" : "bg-up";
    },
    // 自定义轮播：切换到指定幻灯片
    goToSlide(index) {
      this.currentSchoolFeedbackIndex = index;
      this.$nextTick(() => {
        this.adjustWrapperHeight();
      });
    },
    // 动态调整wrapper高度以匹配当前显示的内容
    adjustWrapperHeight() {
      const wrapper = this.$refs.swipeWrapper;
      const track = this.$refs.swipeTrack;
      if (!wrapper || !track) return;

      const items = track.querySelectorAll(".custom-swipe-item");
      if (items.length === 0) return;

      const currentItem = items[this.currentSchoolFeedbackIndex];
      if (currentItem) {
        // 临时禁用过渡动画以确保立即调整高度
        wrapper.style.transition = "none";

        // 获取当前项目的实际内容高度
        // 先重置项目高度以获取自然高度
        currentItem.style.height = "auto";
        const currentHeight = currentItem.scrollHeight;

        // 设置wrapper高度
        wrapper.style.height = `${currentHeight}px`;

        // 强制重排以确保高度计算正确
        wrapper.offsetHeight;

        // 重新启用过渡动画
        this.$nextTick(() => {
          wrapper.style.transition = "height 0.3s ease";
        });

        console.log(
          `调整高度: 索引 ${this.currentSchoolFeedbackIndex}, 高度 ${currentHeight}px`
        );
      }
    },
    // 自定义轮播：初始化触摸事件
    initCustomSwipe() {
      const wrapper = this.$refs.swipeWrapper;
      if (!wrapper) return;

      let startX = 0;
      let startY = 0;
      let isDragging = false;
      let initialTransform = 0;

      const handleStart = (e) => {
        const touch = e.touches ? e.touches[0] : e;
        startX = touch.clientX;
        startY = touch.clientY;
        isDragging = true;
        initialTransform = this.currentSchoolFeedbackIndex * 100;
        const track = this.$refs.swipeTrack;
        if (track) {
          track.style.transition = "none";
        }
      };

      const handleMove = (e) => {
        if (!isDragging) return;

        const touch = e.touches ? e.touches[0] : e;
        const deltaX = touch.clientX - startX;
        const deltaY = touch.clientY - startY;

        // 如果垂直滑动大于水平滑动，不处理
        if (Math.abs(deltaY) > Math.abs(deltaX)) return;

        e.preventDefault();

        const wrapperWidth = wrapper.offsetWidth;
        const movePercent = (deltaX / wrapperWidth) * 100;
        const newTransform = initialTransform - movePercent;

        const track = this.$refs.swipeTrack;
        if (track) {
          track.style.transform = `translateX(-${newTransform}%)`;
        }
      };

      const handleEnd = (e) => {
        if (!isDragging) return;
        isDragging = false;

        const touch = e.changedTouches ? e.changedTouches[0] : e;
        const deltaX = touch.clientX - startX;
        const wrapperWidth = wrapper.offsetWidth;

        const track = this.$refs.swipeTrack;
        if (track) {
          track.style.transition = "transform 0.3s ease";
        }

        // 判断是否切换幻灯片
        if (Math.abs(deltaX) > wrapperWidth * 0.3) {
          if (deltaX > 0 && this.currentSchoolFeedbackIndex > 0) {
            this.currentSchoolFeedbackIndex--;
          } else if (
            deltaX < 0 &&
            this.currentSchoolFeedbackIndex < this.schoolFeedbackData.length - 1
          ) {
            this.currentSchoolFeedbackIndex++;
          }
        }

        // 重置到当前位置并调整高度
        if (track) {
          track.style.transform = `translateX(-${this.currentSchoolFeedbackIndex * 100
            }%)`;
        }
        this.$nextTick(() => {
          this.adjustWrapperHeight();
        });
      };

      // 保存事件处理函数引用，用于后续移除
      this.swipeHandlers = {
        handleStart,
        handleMove,
        handleEnd,
      };

      // 绑定事件
      wrapper.addEventListener("touchstart", handleStart, { passive: false });
      wrapper.addEventListener("touchmove", handleMove, { passive: false });
      wrapper.addEventListener("touchend", handleEnd, { passive: false });

      // 鼠标事件（用于桌面调试）
      wrapper.addEventListener("mousedown", handleStart);
      wrapper.addEventListener("mousemove", handleMove);
      wrapper.addEventListener("mouseup", handleEnd);

      // 阻止鼠标拖拽时的默认行为
      wrapper.addEventListener("dragstart", (e) => e.preventDefault());

      // 监听窗口大小变化，重新调整高度
      this.resizeHandler = () => {
        this.$nextTick(() => {
          this.adjustWrapperHeight();
        });
      };
      window.addEventListener("resize", this.resizeHandler);
    },
    // 清理自定义轮播事件
    cleanupCustomSwipe() {
      const wrapper = this.$refs.swipeWrapper;
      if (!wrapper || !this.swipeHandlers) return;

      const { handleStart, handleMove, handleEnd } = this.swipeHandlers;

      wrapper.removeEventListener("touchstart", handleStart);
      wrapper.removeEventListener("touchmove", handleMove);
      wrapper.removeEventListener("touchend", handleEnd);
      wrapper.removeEventListener("mousedown", handleStart);
      wrapper.removeEventListener("mousemove", handleMove);
      wrapper.removeEventListener("mouseup", handleEnd);

      // 移除resize监听器
      if (this.resizeHandler) {
        window.removeEventListener("resize", this.resizeHandler);
        this.resizeHandler = null;
      }

      this.swipeHandlers = null;
    },
    // 移除touch相关methods（onTestimonialTouchStart, onTestimonialTouchMove, onTestimonialTouchEnd, prevTestimonial, nextTestimonial）
  },
};
</script>

<style lang="scss" scoped>
.home-mobile {
  display: block;
  padding-top: 40px;
  // @media (min-width: 769px) {
  //   display: none;
  // }
}

.hero-section {
  width: 100%;
  height: 100%;
  background: #fff;
  margin-bottom: 20px;
}

.hero-banner {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.hero-title-group {
  text-align: center;
}

.hero-title {
  position: relative;
  font-family: "Alibaba PuHuiTi";
  font-weight: 600;
  font-size: 32px;
  line-height: 1.3;
  color: #232536;
  margin-bottom: 24px;

  .hero-title-underline {
    position: absolute;
    right: 50px;
    top: 30px;
    width: 120px;
    height: auto;
    border-radius: 10px;
    z-index: 0;
    pointer-events: none;
    user-select: none;
  }
}

.hero-btns {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
}

.consult-btn {
  max-width: 280px;
  height: 48px;
  border-radius: 100px;
  background: #ffd24d;
  color: #232536;
  font-size: 18px;
  font-weight: 600;
  border: none;
  box-shadow: none;
  padding: 0 24px;
}

.evaluate-btn {
  min-width: 170px;
  max-width: fit-content;
  font-size: 18px;
  height: 48px;
  border-radius: 100px;
  cursor: pointer;
  border: 1.5px solid #232536;
  font-weight: 600;
  margin-top: 8px;
  background: transparent;
  transition: background 0.2s, color 0.2s, border 0.2s;
  white-space: nowrap;
  display: inline-block;
  text-align: center;
}

.hero-visual-section {
  position: relative;
  width: 100%;
  padding: 0 20px;
  margin-bottom: 20px;
}

.hero-images-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 16px;
  min-height: 160px;
  width: 100%;
}

.hero-images-grid {
  display: flex;
  gap: 12px;
  width: 100%;
  overflow-x: auto;
  padding-bottom: 8px;
  min-height: 220px;
  align-items: center;
  /* 隐藏滚动条 */
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE/Edge */
}

.hero-images-grid::-webkit-scrollbar {
  display: none;
  /* Chrome/Safari/Webkit */
}

.hero-image-item {
  flex: 0 0 auto;
  min-width: 120px;
  max-width: 200px;
  height: 200px;
  border-radius: 12px;
  overflow: hidden;
}

.hero-img {
  width: 100%;
  height: 200px;
  border-radius: 12px;
  object-fit: cover;
  display: block;
}

.responsive-banner {
  /* 默认样式 - 小屏幕 */
  object-position: center center;

  /* 中等屏幕 - 显示图片上部 */
  @media (min-width: 480px) and (max-width: 767px) {
    object-position: center 30%;
  }

  /* 大屏幕 - 显示图片左侧 */
  @media (min-width: 768px) and (max-width: 1023px) {
    object-position: 25% center;
  }

  /* 超大屏幕 - 显示图片右侧 */
  @media (min-width: 1024px) {
    object-position: 75% center;
  }
}

.info-bar {
  width: 100%;
  background: #267e75;
  border-radius: 8px;
  padding: 12px 0;
  min-height: 80px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 20px;
}

.info-bar-content {
  width: 90%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  position: relative;
}

.info-bar-text {
  display: flex;
  font-size: 24px;
  line-height: 32px;
  color: #fff;
  height: 40px;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;

  .info-bar-text-item1 {
    font-size: 26px;
    line-height: 32px;
    color: #fff;
    font-weight: 600;
    margin-right: 12px;
  }

  .info-bar-text-item2 {
    padding-left: 18px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    height: 50px;
    border-left: 1px solid #ced1d9;
    line-height: 16px;

    span:first-child {
      font-size: 16px;
      font-weight: 600;
    }
  }
}

.info-bar-underline {
  position: absolute;
  width: 120px;
  height: 5px;
  top: 5px;
  left: -25px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.partners-section {
  padding: 40px 0px;
  background: #267e75;
}

.partners-logos-row:first-child {
  margin-top: 20px;

}

.partners-logos-row {
  overflow-x: auto;
  white-space: nowrap;
  padding-bottom: 8px;
}

.school-slider {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  width: max-content;
}

.school-slider img {
  height: 60px;
  width: auto;
  object-fit: contain;
  flex-shrink: 0;
  border-radius: 8px;
  padding: 8px;
}

@keyframes slideRight {
  0% {
    transform: translateX(-50%);
  }

  100% {
    transform: translateX(0);
  }
}

.slide-left {
  animation: slideLeft 60s linear infinite;
}

.slide-right {
  animation: slideRight 60s linear infinite;
}

@keyframes slideLeft {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

.caring-guardianship-section {
  padding: 0px 20px;
  min-height: 400px;
  margin-bottom: 20px;
  margin-top: 48px;
}

.caring-container {
  max-width: 100%;
}

.caring-title {
  text-align: left;
  margin-bottom: 32px;
}

.caring-title-text {
  position: relative;
  display: inline-block;
}

.title-text {
  font-family: "Alibaba PuHuiTi", sans-serif;
  font-size: 26px;
  font-weight: 600;
  color: #282938;
  line-height: 1.2;
  display: block;
  position: relative;
}

.title-underline {
  position: absolute;
  right: -7px;
  top: 30px;
  width: 120px;
  height: auto;
  border-radius: 10px;
  z-index: 0;
  pointer-events: none;
  user-select: none;
}

.caring-cards {
  display: flex;
  gap: 20px;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  align-items: flex-start;
}

.caring-cards::-webkit-scrollbar {
  display: none;
}

.caring-card {
  width: 260px;
  min-height: 327px;
  height: auto;
  background: none;
  border-radius: 16px;
  position: relative;
  flex-shrink: 0;
  transition: all 0.3s ease;
  cursor: pointer;
  overflow: visible;
}

.caring-card:hover {
  transform: translateY(-4px);
}

.card-box {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 20px;
  box-sizing: border-box;
  transition: transform 0.3s ease;
  position: relative;
  overflow: visible;
  /* 改为visible，让arrow-box可以显示在外部 */
  min-height: 300px;
}

.bg-down {
  background-image: url("~@/assets/images/down.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

.bg-up {
  background-image: url("~@/assets/images/up.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

.caring-card:hover .card-box {
  transform: scale(1.02);
}

.card-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
  padding-top: 10px;
}

.content-top .text-content {
  margin-bottom: 70px;
  padding-bottom: 60px;
}

.content-bottom .text-content {
  margin-top: 70px;
  padding-top: 40px;
}

.text-content {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.card-title {
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  line-height: 1.3;
}

.gold-text {
  color: #e5ae21;
  font-weight: 600;
  margin-right: 4px;
}

.black-text {
  font-weight: 600;
  color: #282938;
}

.card-subtitle {
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-size: 22px;
  font-weight: 600;
  color: #282938;
  margin-bottom: 10px;
}

.card-description {
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-size: 16px;
  line-height: 1.5;
  color: #282938;
  flex-grow: 0;
  opacity: 0.7;
}

.card-note {
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-size: 13px;
  color: #888;
  margin-top: 6px;
  margin-bottom: 0;
  line-height: 1.4;
  opacity: 0.4;
}

.card-icon {
  display: flex;
  justify-content: flex-start;
  position: absolute;
}

.icon-bottom {
  bottom: 12px;
  left: 12px;
}

/* 只让第一个.icon-bottom的bottom为0，其他为12px */
.icon-bottom {
  bottom: 12px;
  left: 12px;
}

/* 
  如果你想让第一个 .icon-bottom 的 bottom 为 0px，其他为 12px，可以这样实现：
  1. 给第一个 .caring-card 添加一个特殊的 class，比如 first-card
  2. 然后用更具体的选择器覆盖样式
*/

/* 例子： */
/* 在模板中： 
  <div class="caring-card" 
       v-for="(card, index) in caringCards" 
       :key="index" 
       :class="{ 'first-card': index === 0 }"
       @click="handleCardClick(index)">
    ...
  </div>
*/

/* 在样式中： */
.caring-card.first-card .icon-bottom {
  bottom: 0px;
}

.icon-top {
  top: 12px;
  left: 12px;
}

.icon-img {
  width: 80px;
  height: 80px;
  object-fit: contain;
  filter: brightness(1.05);
  opacity: 0.9;
}

.arrow-box {
  width: 50px;
  /* 减小尺寸 */
  height: 50px;
  /* 减小尺寸 */
  background-color: #f4f6fc;
  border-radius: 8px;
  /* 相应减小圆角 */
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  /* 使用更灵活的响应式定位 */
  transform: translateZ(0);
  /* 启用硬件加速 */
}

.arrow-bottom {
  bottom: -20px;
  /* 调整位置，因为arrow-box变小了 */
  right: -12px;
  /* 调整位置，因为arrow-box变小了 */
}

.arrow-top {
  top: -20px;
  /* 调整位置，因为arrow-box变小了 */
  right: -12px;
  /* 调整位置，因为arrow-box变小了 */
}

/* 针对不同屏幕尺寸的响应式调整 */
@media screen and (max-width: 375px) {
  .arrow-bottom {
    bottom: -20px;
    right: -10px;
  }

  .arrow-top {
    top: -20px;
    right: -10px;
  }

  .arrow-box {
    width: 50px;
    /* 小屏幕更小的尺寸 */
    height: 50px;
    /* 小屏幕更小的尺寸 */
  }
}

@media screen and (min-width: 414px) {
  .arrow-bottom {
    bottom: -20px;
    right: -15px;
  }

  .arrow-top {
    top: -20px;
    right: -15px;
  }

  .arrow-box {
    width: 55px;
    /* 中等屏幕适中的尺寸 */
    height: 55px;
    /* 中等屏幕适中的尺寸 */
  }
}

@media screen and (min-width: 768px) {
  .arrow-bottom {
    bottom: -35px;
    right: -18px;
  }

  .arrow-top {
    top: -35px;
    right: -18px;
  }

  .arrow-box {
    width: 60px;
    /* 大屏幕适中的尺寸 */
    height: 60px;
    /* 大屏幕适中的尺寸 */
  }
}

.arrow-img {
  width: 12px;
  /* 减小箭头尺寸 */
  height: 12px;
  /* 减小箭头尺寸 */
  object-fit: contain;
  transition: all 0.3s ease;
  /* 添加平滑过渡效果 */
}

/* 响应式调整箭头图片尺寸 */
@media screen and (max-width: 375px) {
  .arrow-img {
    width: 10px;
    /* 小屏幕更小的箭头 */
    height: 10px;
    /* 小屏幕更小的箭头 */
  }
}

@media screen and (min-width: 414px) {
  .arrow-img {
    width: 14px;
    /* 中等屏幕适中的箭头 */
    height: 14px;
    /* 中等屏幕适中的箭头 */
  }
}

@media screen and (min-width: 768px) {
  .arrow-img {
    width: 16px;
    /* 大屏幕适中的箭头 */
    height: 16px;
    /* 大屏幕适中的箭头 */
  }
}

.accreditation-section {
  width: 90vw;
  height: auto;
  background: #f9d87b;
  padding: 0 0 24px 0;
  padding: 40px 20px;
  border-radius: 20px;
  margin-bottom: 48px;
}

.accreditation-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.accreditation-text {
  display: flex;
  width: 100%;
  margin-bottom: 12px;
  flex-direction: column;
  gap: 20px;
}

.accreditation-label {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #282938;
  opacity: 0.87;
}

.accreditation-title {
  font-weight: 600;
  margin-bottom: 10px;
  color: #282938;
  font-size: 26px;
}

.accreditation-desc {
  font-size: 16px;
  color: #282938;
  margin-bottom: 16px;
  line-height: 2;
  max-width: 100%;
}

.accreditation-btn {
  height: 40px;
  width: 112px;
  margin-top: auto;
  border: 1.5px solid #282938;
  color: #282938;
  background: transparent;
  border-radius: 40px;
  padding: 12px 40px;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.accreditation-img {
  width: 100%;
  max-width: 200px;
  margin: 0 auto;
}

.accreditation-img img {
  width: 100%;
  height: auto;
  border-radius: 20px 20px 0 0;
  object-fit: contain;
  display: block;
}

.meticulous-care-section-flow {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  position: relative;
  padding-top: 48px;
}

.brand-story-bg-flow {
  width: 100%;
  height: 420px;
}

.brand-story-card-flow {
  width: 90vw;
  max-width: 370px;
  border-radius: 20px;
  background: #fff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  z-index: 2;
  position: relative;
}

.brand-story-title {
  font-size: 18px;
  color: #282938;
  opacity: 0.87;
  font-weight: 500;
}

.brand-story-underline {
  position: absolute;
  left: 210px;
  top: 86px;
  transform: translateX(-50%);
  width: 150px;
  height: auto;
  border-radius: 10px;
}

.brand-story-main-title {
  font-size: 26px;
  color: #282938;
  font-weight: 700;
  line-height: 55px;
  text-align: center;
}

.brand-story-desc {
  font-size: 16px;
  line-height: 2;
  color: #282938;
  opacity: 0.6;
  text-align: center;
}

.brand-story-btn {
  min-width: 154px;
  max-width: 200px;
  border: 1.5px solid #282938;
  color: #282938;
  background: transparent;
  border-radius: 40px;
  padding: 8px 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.brand-story-btn:hover {
  background: #282938;
  color: #fff;
}

.who-we-are-section {
  padding: 60px 20px;
}

.who-we-are-img-box {
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
    display: block;
  }
}

.guardian-background-section {
  padding: 20px 20px;
  margin-bottom: 48px;
}

.guardian-title-box {
  text-align: center;
  position: relative;
}

.guardian-title {
  font-family: "Alibaba PuHuiTi";
  font-weight: 600;
  font-size: 32px;
  line-height: 1.3;
  color: #232536;
  position: relative;
  z-index: 1;
}

.guardian-title-underline {
  position: absolute;
  left: 30%;
  bottom: -10px;
  width: 120px;
  height: auto;
  border-radius: 10px;
  z-index: 0;
  pointer-events: none;
  user-select: none;
}

.guardian-bg-table {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
}

.guardian-bg-row {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.guardian-bg-row:last-child {
  border-bottom: none;
}

.guardian-bg-col {
  margin-bottom: 8px;
}

.guardian-bg-col.year {
  font-family: "Alibaba PuHuiTi";
  font-weight: 600;
  font-size: 24px;
  color: #232536;
}

.guardian-bg-col.event {
  font-family: "Alibaba PuHuiTi";
  font-weight: 500;
  font-size: 20px;
  color: #232536;
}

.guardian-bg-col.desc {
  font-family: "Alibaba PuHuiTi";
  font-weight: 400;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.customer-testimonials-section {
  background: #f9fbfd;
  margin-bottom: 48px;
  padding: 48px 20px;
}

.customer-testimonials-title {
  position: relative;
}

.customer-testimonials-underline {
  position: absolute;
  width: 110px;
  height: auto;
  border-radius: 10px;
  z-index: 0;
  pointer-events: none;
  user-select: none;
}

.customer-testimonials-container {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.customer-testimonials-left {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;

  .customer-testimonials-underline {
    position: absolute;
    left: 51px;
    top: 62px;
    width: 110px;
    height: auto;
    border-radius: 10px;
    z-index: 0;
    pointer-events: none;
    user-select: none;
  }

  .testimonial-meta {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-start;
    margin-bottom: 24px;

    .avatar {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      object-fit: cover;
      margin-right: 8px;
    }

    .meta-info {
      .meta-name {
        font-size: 14px;
        font-weight: 500;
        color: #282938;
        margin-bottom: 2px;
      }

      .meta-school {
        color: #282938;
        font-size: 12px;
      }
    }
  }

  .yinhao {
    width: 30px;
    height: 30px;
    object-fit: contain;
    z-index: 1;
    pointer-events: none;
  }

  .testimonial-quote {
    position: relative;

    i {
      font-size: 20px;
      color: #e5ae21;
      margin-bottom: 8px;
      display: block;
    }

    .testimonial-text {
      height: 400px !important;
      font-size: 16px;
      color: #282938;
      line-height: 1.6;
      white-space: pre-line;
      overflow-y: auto;
      /* 允许垂直滚动 */
      position: relative;
      scrollbar-width: none;
      /* Firefox */
      -ms-overflow-style: none;

      /* IE and Edge */
      &::-webkit-scrollbar {
        display: none;
        /* Chrome, Safari, Opera */
      }
    }
  }
}

.customer-testimonials-title {
  font-size: 28px;
  font-weight: 600;
  color: #232536;
  margin-bottom: 48px;
}

.customer-testimonials-desc {
  font-size: 16px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 20px;
}

.customer-testimonials-right {
  display: flex;
  align-items: center;
  justify-content: center;
}

.customer-testimonials-img {
  width: 100%;
  max-width: 400px;
  height: auto;
  border-radius: 16px;
  object-fit: cover;
  display: block;
}

.parent-faq-section {
  padding: 60px 20px;
  margin-bottom: 48px;
}

.parent-faq-container {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.parent-faq-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  text-align: center;
}

.parent-faq-subtitle {
  font-weight: 500;
  font-size: 16px;
  color: #282938;
  margin-bottom: 8px;
}

.parent-faq-title {
  font-weight: 600;
  font-size: 28px;
  color: #232536;
  position: relative;
  text-align: left;
}

.parent-faq-underline {
  position: absolute;
  left: 10px;
  top: 70px;
  width: 120px;
  height: auto;
  border-radius: 10px;
  z-index: 0;
  pointer-events: none;
  user-select: none;
}

.parent-faq-btn {
  border: 1.5px solid #282938;
  color: #282938;
  background: transparent;
  border-radius: 40px;
  padding: 8px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.parent-faq-btn:hover {
  background: #282938;
  color: #fff;
}

.parent-faq-right {
  border-radius: 20px;
  padding: 24px;
  background: #f8f9fa;
}

.parent-faq-list {
  width: 100%;
}

.parent-faq-item {
  border-bottom: 1px solid #eee;
  padding: 0 0 16px 0;
  margin-bottom: 16px;
}

.parent-faq-item:last-child {
  border-bottom: none;
}

.parent-faq-qrow {
  display: flex;
  align-items: baseline;
  cursor: pointer;
  user-select: none;
}

.parent-faq-number {
  font-weight: 500;
  font-size: 20px;
  color: #e5ae21;
  margin-right: 12px;
  flex-shrink: 0;
}

.parent-faq-question {
  font-weight: 500;
  font-size: 18px;
  color: #282938;
  flex: 1;
  line-height: 1.4;
}

.parent-faq-toggle {
  font-size: 24px;
  color: #bbb;
  margin-left: 12px;
  font-weight: 500;
}

.parent-faq-answer {
  font-weight: 500;
  font-size: 16px;
  color: #282938;
  opacity: 0.7;
  margin-top: 12px;
  line-height: 1.5;
  margin-left: 32px;
}

.contact-section {
  width: 100%;
  padding: 40px 20px;
  background: #267e75;
  margin-bottom: 20px;
}

.contact-section-inner {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.contact-section-left {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.contact-section-title {
  font-family: "Alibaba PuHuiTi";
  font-weight: 600;
  font-size: 32px;
  line-height: 1.3;
  color: #fff;
  margin-bottom: 24px;
  text-align: left;
}

.contact-section-desc {
  font-weight: 500;
  font-size: 16px;
  line-height: 1.6;
  color: #fff;
  text-align: left;
  margin-bottom: 0;
}

.contact-section-check {
  color: #fff;
  font-size: 16px;
  margin-right: 8px;
  font-weight: 600;
}

.contact-section-desc-sub {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  opacity: 0.8;
  margin-top: 8px;
}

.contact-section-right {
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-contact-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border-radius: 16px;
}

.qr-img {
  width: 200px;
  height: 200px;
  margin-bottom: 16px;
  border-radius: 10px;
  object-fit: cover;
}

.qr-tip {
  font-size: 14px;
  margin-bottom: 16px;
  text-align: center;
  color: #fff;
}

.contact-info-row {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.contact-info-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.contact-info-label {
  font-size: 16px;
  color: #fff;
  font-weight: 600;
  margin-bottom: 4px;
}

.contact-info-value {
  font-size: 14px;
  color: #fff;
  font-weight: 400;
}

.blog-section {
  padding: 60px 20px;
  background: #fff;
  margin-bottom: 20px;
}

.blog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
}

.blog-title {
  font-family: "Alibaba PuHuiTi";
  font-weight: 600;
  font-size: 32px;
  color: #232536;
}

.blog-more-btn {
  border: 1.5px solid #282938;
  color: #282938;
  background: transparent;
  border-radius: 40px;
  padding: 8px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.blog-more-btn:hover {
  background: #282938;
  color: #fff;
}

.blog-list {
  display: flex;
  flex-direction: column;
}

.blog-card {
  display: flex;
  flex-direction: column;
  text-decoration: none;
  color: inherit;
  border-radius: 20px;
  overflow: hidden;
  transition: transform 0.3s ease;
}

.blog-card:hover {
  transform: translateY(-4px);
}

.blog-img-box {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.blog-img-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.blog-date {
  font-size: 12px;
  color: #888;
  margin: 12px 16px 0 0;
}

.blog-title-text {
  font-size: 18px;
  color: #232536;
  font-weight: 500;
  margin: 8px 16px 0 16px;
  line-height: 1.4;
}

.blog-desc {
  font-size: 14px;
  color: #666;
  margin: 8px 16px 0 16px;
  line-height: 1.5;
}

.blog-link {
  font-size: 12px;
  color: #232536;
  margin: 12px 16px 16px 16px;
  text-decoration: none;
  display: flex;
  align-items: center;
  font-weight: 500;
}

.blog-link span {
  font-size: 14px;
  margin-left: 4px;
}

.info-partners-section {
  background: #267e75;
  margin-bottom: 20px;
  padding-top: 20px;
}

.info-bar {
  background: transparent;
  border-radius: 0;
  min-height: 80px;
}

.partners-section {
  background: transparent;
  padding: 0 0px 40px 0px;
  margin-bottom: 0;
  overflow: hidden;
}

.partners-logos-row {
  overflow: hidden;
  margin-bottom: 10px;
}

.testimonial-bottom-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  // margin-bottom: 48px;
}

.testimonial-desc {
  color: #282938;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
  text-align: center;
}

.testimonial-learn-btn {
  border: 1.5px solid #282938;
  color: #282938;
  background: transparent;
  border-radius: 40px;
  padding: 8px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.testimonial-learn-btn:hover {
  background: #282938;
  color: #fff;
}

/* 学校反馈样式 */
.school-feedback-section {
  padding: 0px 20px;
  background: #fff;
  margin-bottom: 48px;
}

.school-feedback-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 30px;
}

.school-feedback-title-box {
  text-align: left;
  position: relative;
}

.school-feedback-title {
  font-size: 16px;
  font-weight: 500;
  color: #282938;
  margin-bottom: 8px;
  text-align: left;
}

.school-feedback-main-title {
  font-family: "Alibaba PuHuiTi";
  font-size: 28px;
  font-weight: 600;
  color: #282938;
  margin-bottom: 16px;
  position: relative;
  line-height: 1.3;
}

.school-feedback-title-underline {
  position: absolute;
  bottom: 6px;
  transform: translateX(-50%);
  width: 120px;
  height: auto;
  border-radius: 10px;
  z-index: 0;
  pointer-events: none;
  user-select: none;
}

.school-feedback-carousel {
  width: 100%;
  max-width: 400px;
}

/* 自定义轮播容器 */
.custom-swipe-container {
  width: 100%;
  position: relative;
  overflow: hidden;
}

.custom-swipe-wrapper {
  width: 100%;
  position: relative;
  touch-action: pan-y;
  transition: height 0.3s ease;
  height: auto;
  min-height: 0;
}

.custom-swipe-track {
  display: flex;
  transition: transform 0.3s ease;
  width: 100%;
  position: relative;
  align-items: flex-start;
}

.custom-swipe-item {
  width: 100%;
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  min-height: auto;
  height: auto;
  position: relative;
  flex: 0 0 auto;
}

/* 自定义指示器样式（保持与原van-swipe一致） */
.custom-swipe-indicators {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 8px;
}

.custom-indicator {
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 10px;
  height: 10px;
  background: #fff;
  border: 2px solid #282938;
  opacity: 0.7;
  transition: all 0.3s;
  box-shadow: 0 2px 8px rgba(40, 41, 56, 0.08);
}

.custom-indicator-active {
  width: 40px;
  height: 10px;
  border-radius: 8px;
  background: #282938;
  opacity: 1;
  border-color: #282938;
}

.feedback-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  gap: 20px;
  height: fit-content;
  min-height: fit-content;
  width: 100%;
  padding: 10px 0;
  box-sizing: border-box;
}

.school-icon {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.school-icon img {
  object-fit: contain;
  max-width: 100%;
  height: auto;
}

.school-icon img[src*="schoolicon1"] {
  width: 60px;
  height: 74px;
}

.school-icon img[src*="schoolicon2"] {
  width: 66px;
  height: 85px;
}

.school-icon img[src*="schoolicon3"] {
  width: 348px;
  height: 60px;
}

.feedback-author {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-bottom: 20px;
}

.author-name {
  font-family: "Alibaba PuHuiTi";
  font-size: 20px;
  font-weight: 500;
  color: #282938;
  margin-bottom: 6px;
}

.author-title {
  font-family: "Alibaba PuHuiTi";
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  line-height: 1.4;
  white-space: pre-line;
}

.feedback-quote {
  display: flex;
  position: relative;
  border-radius: 16px;
  gap: 12px;
  height: fit-content;
  min-height: fit-content;
  width: 100%;
  align-items: flex-start;
}

.quote-mark-left {
  width: 32px;
  height: 18px;
  object-fit: contain;
  flex-shrink: 0;
}

.quote-mark-right {
  width: 32px;
  height: 18px;
  object-fit: contain;
  flex-shrink: 0;
}

.quote-text {
  font-family: "Alibaba PuHuiTi";
  font-size: 14px;
  color: #282938;
  line-height: 1.6;
  text-align: left;
  font-weight: 400;
  flex: 1;
  min-height: fit-content;
  height: fit-content;
}

.quote-text-line {
  margin-bottom: 0;
  white-space: normal;
  word-wrap: break-word;
  line-height: 1.6;
}
</style>
